import { QueryProps } from "@/types/Api";
import { api } from "..";

import { UserOptions } from "@/types/User";
import {
  ColumnOrderState,
  ColumnSizingState,
  VisibilityState,
} from "@tanstack/react-table";
interface UpdateTablesColumnParams {
  id: string;
  payload: {
    columnVisibility: VisibilityState;
    columnOrder: ColumnOrderState;
    columnSizing: ColumnSizingState;
  };
}
export async function updateTablesColumn(
  props: QueryProps<UpdateTablesColumnParams>
): Promise<UserOptions> {
  const res = await api.client.put(
    `/users/update-tables-column`,
    props.params,
    {
      signal: props.signal,
    }
  );
  return res.data;
}
